module.exports = __webpack_public_path__ + "static/media/sk.253c1938.svg";